import z from "zod"

const stockStatusFilterValues = [
	"IN_STOCK",
	"IN_USE",
	"INCOMING",
	"REMOVED",
	"INCOMING_PRE_PRODUCTION",
	"INCOMING_PRODUCED",
] as const

export const stockStatusFilterSchema = z.enum(stockStatusFilterValues)
export type StockStatusFilter = z.infer<typeof stockStatusFilterSchema>
